import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useUserRoles } from "../auth/useUserRoles";

interface UserProfileProps {
  className?: string;
}

export const UserProfile: React.FC<UserProfileProps> = ({ className = "" }) => {
  const { user, logout } = useAuth0();
  const { roles } = useUserRoles();

  if (!user) return null;

  return (
    <div className={`user-profile ${className}`}>
      <div className="user-info">
        <div className="user-avatar">
          {user.picture ? (
            <img src={user.picture} alt={user.name} />
          ) : (
            <div className="avatar-placeholder">
              {user.name?.charAt(0) || user.email?.charAt(0) || "?"}
            </div>
          )}
        </div>
        <div className="user-details">
          <div className="user-name">{user.name || user.email}</div>
          <div className="user-email">{user.email}</div>
          <div className="user-roles">
            {roles.length > 0 ? roles.join(", ") : "No roles assigned"}
          </div>
        </div>
      </div>
      <button
        className="logout-button"
        onClick={() =>
          logout({
            logoutParams: {
              returnTo: window.location.origin,
              federated: false, // Only logout from Auth0, not federated identity providers
            },
          })
        }
        title="Log out (Auth0 only - WhatsApp Web session remains active)"
      >
        🚪 Logout
      </button>
    </div>
  );
};
